import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

interface Props {
  label: string;
  description?: string;
  value: unknown;
  onChange: (v: unknown) => void;
}

const JsonField: React.FC<Props> = ({ label, description, value, onChange }) => {
  const text = typeof value === 'string' ? value : JSON.stringify(value ?? {}, null, 2);

  return (
    <Box>
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#141417', mb: 0.5, fontFamily: 'Manrope, sans-serif' }}>{label}</Typography>
      {description && <Typography sx={{ fontSize: 11, color: '#6F6F6F', mb: 0.5 }}>{description}</Typography>}
      <TextField
        fullWidth
        size="small"
        multiline
        minRows={4}
        value={text}
        onChange={(e) => {
          try { onChange(JSON.parse(e.target.value)); } catch { /* let user keep typing */ }
        }}
        InputProps={{ sx: { fontSize: 12, fontFamily: 'monospace', borderRadius: '6px' } }}
      />
    </Box>
  );
};

export default JsonField;
